import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetState, StateStatus } from '@guryou/redux';

import { getArchivedMemberships, PROVIDER_ARCHIVED_MEMBERSHIPS, PROVIDER_MEMBERSHIPS, RESTORE_MEMBERSHIP } from '../new/membership';

const useArchivedMemberships = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.membership.archived);
  const restore = useSelector(state => state.membership.restore);

  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getArchivedMemberships());
      return;
    }
    if (restore.version) {
      dispatch(resetState(PROVIDER_ARCHIVED_MEMBERSHIPS));
      restore.version && dispatch(resetState(RESTORE_MEMBERSHIP));
    }
  }, [data, dispatch, status, restore.version]);

  useEffect(() => {
    return () => {
      dispatch(resetState(PROVIDER_ARCHIVED_MEMBERSHIPS));
      dispatch(resetState(PROVIDER_MEMBERSHIPS));
    };
  }, [dispatch]);

  return { data: data || [], status, version, entity };
};

export default useArchivedMemberships;
